import React from "react";
import { useLocation } from "react-router-dom";
import { CommandPalette } from "./CommandPalette";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { pathname } = useLocation();

  return (
    // The rail runs the FULL height on the left and carries the brand,
    // navigation and the account menu. There is no bar above the page — the
    // content starts at the top of the viewport, so nothing competes with the
    // page's own heading. `Header` renders only below `lg`, where the rail is
    // hidden and the drawer still needs a way to open.
    <div className="flex h-screen bg-canvas">
      {/* Sidebar — full height, fixed-width icon rail */}
      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* Mobile-only nav bar; renders nothing on desktop. */}
        <Header />

        {/* Main content — one consistent page wrapper (centered, capped width,
            responsive horizontal padding) so every route has the same gutters.
            Pages should NOT add their own max-width / horizontal padding. */}
        <main className="flex-1 overflow-y-auto bg-background">
          {/* Keyed by path so React remounts on navigation and the entrance
              animation replays — without a key the class is already applied
              and the new page would simply appear. */}
          <div
            key={pathname}
            // max-w-7xl (1280px) left ~300px dead on each side of a 1920px
            // screen, which read as a thin column rather than a dashboard.
            // 1600px fills a wide monitor while still stopping lines of body
            // text from running too long to scan.
            className="mx-auto w-full max-w-[1600px] animate-fade-in px-4 py-6 sm:px-6 lg:px-8"
          >
            {children}
          </div>
        </main>
      </div>

      {/* The search bar is gone from the chrome, but the palette stays mounted
          so ⌘K / Ctrl+K still jumps to any project, service or page. */}
      <CommandPalette showTrigger={false} />
    </div>
  );
}
